/* ============================================================
   OS9 BROWSER — GeoCities Gallery home page
   squiche.com

   Registers: window.OS9BrowserPages['geocities']

   Data source (theme-editor-safe):
     <script type="application/json" id="os9-geo-config">
   Falls back to window.OS9Config.geoConfig.
   ============================================================ */

(function () {
  'use strict';

  /* ═══════════════════════════════════════════════════════════
     § 1  CSS
  ═══════════════════════════════════════════════════════════ */

  // Background image — CDN cloud tile (overridable via geoConfig.backgroundUrl)
  var DEFAULT_BG_URL = 'https://cdn.shopify.com/s/files/1/0777/2844/8754/files/cloud-preview.png?v=1779834185';

  var CSS = [
    '.geo*{box-sizing:border-box;margin:0;padding:0;}',

    /* background injected by injectCSS() */
    '.geo{min-height:400px;font-family:"Comic Sans MS",cursive;',
    'padding:8px 12px 20px;color:#000;overflow-x:hidden;}',

    '.geo-gallery{display:block;}.geo-image-page{display:none;}',
    '.geo.showing-image .geo-gallery{display:none;}',
    '.geo.showing-image .geo-image-page{display:block;}',

    /* flames */
    '.geo-flames{text-align:center;font-size:18px;line-height:1;white-space:nowrap;overflow:hidden;',
    'animation:geo-flicker 0.2s infinite alternate;}',
    '.geo-flames-flip{text-align:center;font-size:18px;line-height:1;overflow:hidden;',
    'white-space:nowrap;transform:scaleY(-0.4);opacity:0.5;margin-top:-2px;}',
    '@keyframes geo-flicker{from{filter:drop-shadow(0 0 3px #f60);}to{filter:drop-shadow(0 0 7px #f00) brightness(1.1);}}',

    /* title */
    '.geo-title-img{display:block;margin:4px auto 2px;max-width:100%;height:auto;',
    'pointer-events:none;-webkit-user-drag:none;}',
    '.geo-subtitle{text-align:center;font-size:12px;color:#000080;font-family:Verdana,sans-serif;margin-bottom:6px;}',

    /* marquee */
    '.geo-marquee{background:#ff0;border-top:1px solid #ccc;border-bottom:1px solid #ccc;padding:2px 0;',
    'overflow:hidden;white-space:nowrap;margin-bottom:12px;font-family:Verdana,sans-serif;font-size:11px;color:#c00;font-weight:bold;}',
    '.geo-marquee-inner{display:inline-block;padding-left:100%;animation:geo-scroll 22s linear infinite;}',
    '@keyframes geo-scroll{from{transform:translateX(0);}to{transform:translateX(-100%);}}',

    /* visitor counter */
    '.geo-counter-block{text-align:center;margin-bottom:14px;}',
    '.geo-counter-label-top{font-family:Verdana,sans-serif;font-size:10px;color:#000080;font-weight:bold;margin-bottom:3px;}',
    '.geo-counter{display:inline-block;background:#000;color:#0f0;font-family:"Courier New",monospace;',
    'font-size:20px;font-weight:bold;padding:4px 10px;letter-spacing:4px;border:1px inset #333;}',
    '.geo-counter-sublabel{font-family:Verdana,sans-serif;font-size:9px;color:#555;margin-top:2px;}',

    /* gallery grid */
    '.geo-gallery-intro{font-family:Verdana,sans-serif;font-size:12px;color:#000080;',
    'font-weight:bold;text-align:center;margin-bottom:8px;}',
    '.geo-grid{display:grid;grid-template-columns:repeat(3,1fr);gap:10px;max-width:600px;margin:0 auto;}',
    '@media(max-width:440px){.geo-grid{grid-template-columns:repeat(2,1fr);}}',

    /* thumbs */
    '.geo-thumb{text-align:center;cursor:pointer;font-family:Verdana,sans-serif;}',
    '.geo-thumb:hover .geo-thumb-name{color:#f0f;}',
    '.geo-thumb:focus{outline:2px dotted #000080;outline-offset:2px;}',
    '.geo-thumb-img-wrap{background:#fff;border:2px solid #00a;padding:3px;display:block;width:100%;overflow:hidden;}',
    '.geo-thumb-img-wrap img{width:100%;aspect-ratio:1;object-fit:cover;display:block;',
    'pointer-events:none;-webkit-user-drag:none;user-select:none;-webkit-user-select:none;}',
    '.geo-thumb-placeholder{width:100%;aspect-ratio:1;display:flex;flex-direction:column;',
    'align-items:center;justify-content:center;background:#ccc;font-size:9px;',
    'font-family:Verdana,sans-serif;color:#555;gap:2px;pointer-events:none;}',
    '.geo-thumb-placeholder.broken{background:#111;color:#f66;}',
    '.geo-thumb-name{font-size:10px;color:#0000ee;text-decoration:underline;display:block;',
    'margin-top:3px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}',
    '.geo-thumb-meta{font-size:9px;color:#555;margin-top:1px;}',
    '.geo-new{color:#c00;font-weight:bold;}.geo-feat{color:#c0c;}',

    /* under construction */
    '.geo-construction{margin-top:12px;font-family:Verdana,sans-serif;font-size:11px;',
    'color:#c00;font-weight:bold;text-align:center;}',
    '.geo-blink{animation:geo-blink 1s step-end infinite;}',
    '@keyframes geo-blink{50%{opacity:0;}}',

    /* image detail page */
    '.geo-back-link{display:inline-block;font-size:12px;font-family:Verdana,sans-serif;',
    'color:#0000ee;text-decoration:underline;cursor:pointer;margin-bottom:8px;}',
    '.geo-back-link:hover{color:#f0f;}',
    '.geo-image-title{font-family:"Comic Sans MS",cursive;font-size:20px;font-weight:bold;',
    'color:#000080;text-align:center;margin-bottom:8px;}',
    '.geo-full-img-wrap{background:#fff;border:3px solid #00a;padding:6px;',
    'max-width:540px;margin:0 auto 10px;text-align:center;user-select:none;-webkit-user-select:none;}',
    '.geo-full-img-wrap img{max-width:100%;display:block;margin:0 auto;',
    'pointer-events:none;-webkit-user-drag:none;}',
    '.geo-full-placeholder{background:#e8e8e8;min-height:240px;display:flex;',
    'align-items:center;justify-content:center;flex-direction:column;',
    'color:#888;font-size:13px;font-family:Verdana,sans-serif;gap:8px;}',
    '.geo-watermark-text{font-size:10px;color:#aaa;text-align:right;margin-top:3px;font-family:Verdana,sans-serif;}',

    /* detail table */
    '.geo-img-details{max-width:540px;margin:0 auto 10px;border:1px solid #00a;',
    'background:#ffffcc;font-size:11px;font-family:Verdana,sans-serif;border-collapse:collapse;width:100%;}',
    '.geo-img-details td{padding:3px 8px;border-bottom:1px dotted #99c;vertical-align:top;}',
    '.geo-img-details td:first-child{color:#00a;font-weight:bold;white-space:nowrap;width:90px;}',
    '.geo-img-details a{color:#0000ee;}',
    /* Shop links keep the Geocities look on purpose \u2014 this page is */
    /* pastiche, not OS9 chrome, so it does not use the OS9 tokens. */
    '.geo-shop-link{font-weight:bold;color:#c00 !important;text-decoration:underline;}',
    '.geo-shop-link:hover{background:#ff9;}',

    /* share box */
    '.geo-share-box{max-width:540px;margin:0 auto 10px;background:#e8e8ff;',
    'border:1px solid #99c;padding:6px 10px;font-size:10px;font-family:Verdana,sans-serif;}',
    '.geo-share-box p{font-weight:bold;color:#000080;margin-bottom:4px;}',
    '.geo-share-row{display:flex;gap:6px;align-items:center;margin-top:3px;}',
    '.geo-share-label{color:#333;min-width:68px;white-space:nowrap;font-size:10px;}',
    '.geo-share-input{flex:1;font-family:"Courier New",monospace;font-size:9px;color:#00a;',
    'background:#fff;border:1px inset #ccc;padding:2px 4px;min-width:0;}',
    '.geo-share-copy{background:#c0c0c0;border:1px outset #fff;font-size:9px;',
    'font-family:Tahoma,Verdana,sans-serif;padding:2px 6px;cursor:pointer;white-space:nowrap;color:#000;}',
    '.geo-share-copy:active{border-style:inset;}',

    /* comments */
    '.geo-comments-box{max-width:540px;margin:0 auto 10px;font-family:Verdana,sans-serif;}',
    '.geo-comments-heading{font-size:12px;font-weight:bold;color:#000080;text-decoration:underline;margin-bottom:4px;}',
    '.geo-comment{font-size:11px;border-bottom:1px dotted #99c;padding:3px 0;color:#333;}',
    '.geo-comment-author{color:#0000ee;font-weight:bold;}',

    /* Scrollbar styling intentionally NOT defined here — the global
       [id^="os9-page-"]::-webkit-scrollbar rules in os9-windows.css
       apply to #os9-page-home automatically and produce the OS9 purple-
       grid scrollbar that matches the rest of the OS. Previously this
       module injected a beige Windows-95-style scrollbar that overrode
       the OS9 one — removed so the geocities page matches SquichaVista. */
  ].join('');

  function injectCSS(backgroundUrl) {
    var id  = 'os9-geocities-css';
    var url = backgroundUrl || DEFAULT_BG_URL;
    var full = CSS.replace(
      '.geo{min-height:400px;',
      '.geo{background:url(' + JSON.stringify(url) + ') repeat;background-size:auto;min-height:400px;'
    );

    var el = document.getElementById(id);
    if (el) { el.textContent = full; return; }
    var s = document.createElement('style');
    s.id = id; s.textContent = full;
    document.head.appendChild(s);
  }

  /* ═══════════════════════════════════════════════════════════
     § 2  CONFIG READER (theme-editor-safe)
  ═══════════════════════════════════════════════════════════ */

  function getGeoCfg() {
    var el = document.getElementById('os9-geo-config');
    if (el) { try { return JSON.parse(el.textContent) || {}; } catch (e) {} }
    return (window.OS9Config && window.OS9Config.geoConfig) || {};
  }

  /* ═══════════════════════════════════════════════════════════
     § 3  STORAGE — persistent counts + session dedup
     localStorage  → counts that survive page reloads
     sessionStorage → "already counted this session" flags
     Closing + reopening the site = new session = new count ✓
     Clicking back/forward within a session = no re-increment ✓
  ═══════════════════════════════════════════════════════════ */

  var LS_VIEWS    = 'geo_img_views';     // {imageName: count}
  var LS_VISITORS = 'geo_visitors';      // number
  var SS_VISITED  = 'geo_sess_visited';  // '1' once visitor counted
  var LS_FETCHED  = 'geo_views_fetched'; // {imageName: msTimestamp of last /get/}

  /* The counter's budget is small (see the queue below), and the gallery has
     ~97 thumbnails — far more than one page load can ever refresh. So a count
     we already fetched recently is reused instead of re-spending budget on it.
     Kept in its own key so LS_VIEWS stays a plain {name: count} map for
     getViewCount() and the rest of the callers. */
  var VIEW_TTL_MS = 6 * 60 * 60 * 1000;  // 6 hours

  function getFetchedAt()   { try { return JSON.parse(lsGet(LS_FETCHED) || '{}'); } catch(e) { return {}; } }
  function markFetched(name) {
    var m = getFetchedAt();
    m[name] = Date.now();
    lsSet(LS_FETCHED, JSON.stringify(m));
  }
  function isFresh(name) {
    var t = getFetchedAt()[name];
    return !!t && (Date.now() - t) < VIEW_TTL_MS;
  }

  function lsGet(key)      { try { return localStorage.getItem(key);       } catch(e) { return null; } }
  function lsSet(key, val) { try { localStorage.setItem(key, val);         } catch(e) {} }
  function ssGet(key)      { try { return sessionStorage.getItem(key);     } catch(e) { return null; } }
  function ssSet(key, val) { try { sessionStorage.setItem(key, val);       } catch(e) {} }

  function getStoredViews()    { try { return JSON.parse(lsGet(LS_VIEWS) || '{}'); } catch(e) { return {}; } }
  function saveStoredViews(v)  { lsSet(LS_VIEWS, JSON.stringify(v)); }

  /* Last visitor total we successfully displayed. LS_VISITORS was declared
     from the start but never actually written, so every failed Abacus call
     dropped the display back to the bare seed and the counter visibly ran
     BACKWARDS (observed: 031662 -> 031424, exactly the live count lost).
     A hit counter that goes down is the one thing a real 1998 hit counter
     never did, so we remember the high-water mark and never render below it. */
  function getCachedVisitorTotal() {
    var n = parseInt(lsGet(LS_VISITORS), 10);
    return (isFinite(n) && n > 0) ? n : 0;
  }
  function setCachedVisitorTotal(n) { lsSet(LS_VISITORS, String(n)); }

  // Floor for the visitor display: never show less than the seed, and never
  // less than the highest total this browser has already seen.
  function visitorFloor(seed) { return Math.max(seed || 0, getCachedVisitorTotal()); }

  // Every image open counts. Increments the local cache for an immediate
  // optimistic +1, fires a global hit on Abacus, and replaces the local
  // cache with the server's authoritative count when it returns. The
  // previous session-dedup (one count per image per browser session) was
  // removed — opening the same image twice now counts as two views, which
  // is what users actually expect.
  function getOrIncrementView(name, onGlobalUpdate) {
    var views = getStoredViews();
    var count = (views[name] || 0) + 1;
    views[name] = count;
    saveStoredViews(views);

    fetchAndIncrementImage(name, function (globalCount) {
      if (globalCount == null) return;
      var v = getStoredViews();
      v[name] = globalCount;
      saveStoredViews(v);
      if (typeof onGlobalUpdate === 'function') onGlobalUpdate(globalCount);
    });

    return count;
  }

  function getViewCount(name) {
    return getStoredViews()[name] || 0;
  }

  /* Backfill the gallery's view counts from the shared counter.

     buildGalleryHTML() renders from the local cache, so a visitor who had
     never opened an image saw "0 views" on every thumbnail even though the
     shared counter held real numbers — the counts only ever reflected that
     one browser's own clicks. /get/ reads without incrementing, so this is
     safe to call for every thumbnail on every render. Failures are ignored:
     the local number stays on screen rather than flashing to zero. */
  function hydrateGalleryCounts(root, images) {
    if (!root || !images || !images.length) return;

    /* The gallery can hold ~100 thumbnails. Firing that many requests at once
       risks rate-limiting the shared counter (and wastes them on thumbs the
       visitor never scrolls to), so each is fetched only when it comes into
       view. Falls back to fetching everything where IntersectionObserver is
       unavailable. */
    var pending = {};
    images.forEach(function (img, idx) {
      var span = root.querySelector('[data-geo-count="' + idx + '"]');
      if (span) pending[idx] = span;
    });

    /* Prime the first screenful unconditionally. The observer alone left these
       at "0 views" on load: the gallery scrolls inside its own container, not
       the viewport, so intersection wasn't reported until the user scrolled. */
    /* Was 24 — exactly the size of the counter's token bucket, so first paint
       drained it and every later request 429'd. Keep the opening burst small
       and let the IntersectionObserver trickle the rest in as the user scrolls. */
    var PRIME = 8;
    images.slice(0, PRIME).forEach(function (img, idx) { fetchCount(img, idx); });

    if (window.IntersectionObserver) {
      /* Observe against the scrolling page container rather than the viewport,
         for the same reason. */
      var scrollRoot = root.closest ? root.closest('[id^="os9-page-"]') : null;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var idx = Number(e.target.getAttribute('data-geo-count'));
          io.unobserve(e.target);
          fetchCount(images[idx], idx);
        });
      }, { root: scrollRoot || null, rootMargin: '400px' });
      Object.keys(pending).forEach(function (idx) {
        if (Number(idx) >= PRIME) io.observe(pending[idx]);
      });
      return;
    }
    images.forEach(function (img, idx) { fetchCount(img, idx); });

    function fetchCount(img, idx) {
      if (!img) return;
      // Already refreshed recently — the cached number is on screen, leave the
      // request budget for thumbnails we know nothing about.
      if (isFresh(img.name)) return;
      queueCounterFetch(
        COUNTER_BASE + '/get/' + COUNTER_NS + '/' + counterKey(img.name),
        function (value) {
          if (value == null) return;   /* 404 = nobody has opened it yet */
          markFetched(img.name);
          var v = getStoredViews();
          v[img.name] = value;
          saveStoredViews(v);
          var span = root.querySelector('[data-geo-count="' + idx + '"]');
          if (span) span.textContent = value;
        }
      );
    }
  }

  /* Shared counter service — abacus.jasoncameron.dev.
     The previous service (api.countapi.xyz) shut down sometime in
     2024-2025, which is why the visitor counter froze at the seed.
     Abacus is a free drop-in replacement: same URL pattern, same
     {value: N} response shape, no API key needed.

     DURABILITY NOTE: this is a free third-party service that could
     also go away. For a truly bulletproof counter, deploy a tiny
     Cloudflare Workers + KV endpoint on your own domain — same code,
     swap COUNTER_BASE to it. ~30 min setup, free up to 100k hits/day.
     Until then, expect the displayed total to occasionally reset to
     just the seed if Abacus goes down. */
  /* COUNTER_BASE is set from the theme editor's "Counter API URL" field
     in the GeoCities Home Page block. mount() overwrites this when a
     custom URL (e.g. a Cloudflare Worker) is configured. Blank in
     theme settings → falls back to Abacus. */
  var COUNTER_BASE = 'https://abacus.jasoncameron.dev';
  var COUNTER_NS   = 'squiche-store';

  /* ── REQUEST QUEUE ──────────────────────────────────────────
     Abacus is free and rate-limits bursts. The gallery primes 24 thumbnails
     on load (PRIME below), and firing those as 24 parallel fetches meant
     ~20 of 24 came back 429 — fetchCount treated a 429 the same as a miss,
     so most thumbnails silently kept showing "0 views" even though the
     shared counter held real numbers.

     Measured behaviour of the live service (2026-08-27): it is a token
     bucket of roughly 24 requests that refills at only ~0.5/sec. Neither
     rate nor concurrency alone is the trigger — 10 sequential requests at
     6.7/sec pass, and 4 concurrent pass, but sustained throughput above
     the refill rate drains the bucket and everything after that 429s.
     PRIME was 24, which drained the whole bucket on first paint.

     So the queue throttles on BOTH axes: at most COUNTER_MAX_INFLIGHT open
     at once, AND at least COUNTER_MIN_INTERVAL_MS between starts, which
     keeps us under the refill rate. A 429 is retried with exponential
     backoff rather than thrown away. Priority jobs (the visitor counter,
     opening an image) jump the line so the numbers a user is actually
     looking at never sit behind the background thumbnail backfill. */
  var COUNTER_MAX_INFLIGHT    = 2;
  var COUNTER_MIN_INTERVAL_MS = 1800;   // ~0.55/sec, just under the refill rate
  var COUNTER_MAX_RETRIES     = 3;
  var COUNTER_BACKOFF_MS      = 2000;

  var counterQueue      = [];
  var counterInFlight   = 0;
  var counterLastStart  = 0;
  var counterPumpTimer  = null;

  /* url → the endpoint to GET; cb(value|null) → always called exactly once,
     with the numeric count or null once retries are exhausted. */
  function queueCounterFetch(url, cb, priority) {
    var job = { url: url, cb: cb, tries: 0 };
    if (priority) counterQueue.unshift(job); else counterQueue.push(job);
    pumpCounterQueue();
  }

  function pumpCounterQueue() {
    if (counterPumpTimer) return;   // a pump is already scheduled; it will drain
    while (counterInFlight < COUNTER_MAX_INFLIGHT && counterQueue.length) {
      var now  = Date.now();
      var wait = counterLastStart + COUNTER_MIN_INTERVAL_MS - now;
      if (wait > 0) {
        counterPumpTimer = setTimeout(function () {
          counterPumpTimer = null;
          pumpCounterQueue();
        }, wait);
        return;
      }
      counterLastStart = now;
      counterInFlight++;
      runCounterJob(counterQueue.shift());
    }
  }

  function runCounterJob(job) {
    var settled = false;

    function finish(value) {
      if (settled) return;
      settled = true;
      counterInFlight--;
      try { job.cb(value); } catch (e) {}
      pumpCounterQueue();
    }

    function retry() {
      if (settled) return;
      settled = true;
      counterInFlight--;
      job.tries++;
      var wait = COUNTER_BACKOFF_MS * Math.pow(2, job.tries - 1);
      setTimeout(function () { counterQueue.push(job); pumpCounterQueue(); }, wait);
    }

    fetch(job.url)
      .then(function (r) {
        // 429 = rate limited. Back off and try again rather than losing the count.
        if (r.status === 429 && job.tries < COUNTER_MAX_RETRIES) { retry(); return; }
        // 404 = key doesn't exist yet (nobody has opened that image). Not an error.
        if (!r.ok) { finish(null); return; }
        return r.json().then(function (d) {
          finish(d && d.value != null ? d.value : null);
        }, function () { finish(null); });
      })
      .catch(function () {
        // Network-level failure — worth one more attempt, then give up quietly.
        if (job.tries < COUNTER_MAX_RETRIES) retry(); else finish(null);
      });
  }

  function counterKey(name) {
    return 'img-' + String(name).replace(/[^a-zA-Z0-9._-]/g, '-').slice(0, 80);
  }

  // alreadyVisited — if true, GETs without incrementing; if false, HITs and increments.
  // callback(value|null) — called async with the global count, or null on any failure.
  function fetchAndIncrementVisitor(alreadyVisited, callback) {
    var endpoint = COUNTER_BASE + '/' +
      (alreadyVisited ? 'get' : 'hit') + '/' + COUNTER_NS + '/visitors';
    // priority: the visitor number is the most visible thing on the page,
    // so it must not queue behind the gallery's thumbnail backfill.
    queueCounterFetch(endpoint, callback, true);
  }

  // Per-image global hit — fires when a user opens an image detail page.
  // Returns the new global count via callback (or null on failure).
  function fetchAndIncrementImage(name, callback) {
    /* Sanitize the filename into a URL-safe key. Replace anything that's
       not alphanumeric, dash, underscore, or dot with a dash. */
    // priority: fired when the user opens an image, so it's an interaction
    // they're waiting on rather than background backfill.
    queueCounterFetch(
      COUNTER_BASE + '/hit/' + COUNTER_NS + '/' + counterKey(name),
      callback, true
    );
  }

  // Fisher-Yates shuffle — returns a new shuffled copy of an array.
  function shuffleArr(arr) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j   = Math.floor(Math.random() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  /* ═══════════════════════════════════════════════════════════
     § 4  ANIMATION
  ═══════════════════════════════════════════════════════════ */

  function padded(n, len) {
    var s = String(Math.round(n));
    while (s.length < len) s = '0' + s;
    return s;
  }

  function animateCount(el, from, to, duration, pad) {
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var prog  = Math.min((ts - start) / duration, 1);
      var eased = 1 - Math.pow(1 - prog, 3);
      var val   = Math.round(from + (to - from) * eased);
      el.textContent = pad ? padded(val, pad) : String(val);
      if (prog < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ═══════════════════════════════════════════════════════════
     § 5  HTML BUILDERS
  ═══════════════════════════════════════════════════════════ */

  function buildGalleryHTML(cfg) {
    var title    = cfg.title    || '✨ COOL ART BY SQUICHE ✨';
    var subtitle = cfg.subtitle || "Philadelphia's #1 Art Gallery Since 1999 ★ All artwork by squiche";
    var marquee  = cfg.marquee  || '★★★ WELCOME!! NEW PICS ADDED EVERY WEEK!! ★★★ BEST VIEWED IN 800x600 ★★★ NO HOTLINKING!! ★★★';
    var images   = cfg.images   || [];
    var since    = cfg.counterSince || 'Jan 1, 1999';

    var thumbsHtml = images.length
      ? images.map(function (img, idx) {
          var count    = getViewCount(img.name);
          var flag     = img.flag || '';
          var flagHtml = flag === 'new'      ? '<span class="geo-new">★ NEW</span> &middot; '
                       : flag === 'featured' ? '<span class="geo-feat">★ Featured</span> &middot; '
                       : '';
          var inner    = flag === 'broken'
            ? '<div class="geo-thumb-placeholder broken">⚠️<br>IMAGE NOT FOUND</div>'
            : img.thumb
              ? '<img src="' + img.thumb + '" alt="' + img.name + '" loading="lazy">'
              : '<div class="geo-thumb-placeholder">🖼️<br>' + img.name + '</div>';

          return '<div class="geo-thumb" tabindex="0" data-geo-index="' + idx + '">' +
            '<div class="geo-thumb-img-wrap">' + inner + '</div>' +
            '<span class="geo-thumb-name">' + img.name + '</span>' +
            '<div class="geo-thumb-meta">' + flagHtml +
              '<span data-geo-count="' + idx + '">' + count + '</span> views' +
            '</div></div>';
        }).join('')
      : '<div class="geo-thumb"><div class="geo-thumb-img-wrap">' +
        '<div class="geo-thumb-placeholder">🖼️<br>Upload images<br>in theme editor</div>' +
        '</div></div>'.repeat(3);

    var titleHtml = cfg.titleImageUrl
      ? '<img class="geo-title-img" src="' + cfg.titleImageUrl + '" alt="' + title + '" draggable="false">'
      : '<div style="font-family:\'Comic Sans MS\',cursive;font-size:clamp(18px,4vw,28px);font-weight:bold;' +
        'text-align:center;color:#f00;text-shadow:2px 2px 0 #ff0;margin:4px 0 2px;line-height:1.2;">' + title + '</div>';

    var seed = cfg.counterSeed || 0;
    /* Paint the last total we know about, not the bare seed — otherwise a
       returning visitor sees the number flash DOWN to the seed and then
       climb back up. showGallery() fires the API and animates from here. */

    return '' +
      '<div class="geo-flames">🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥</div>' +
      titleHtml +
      '<div class="geo-flames-flip">🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥🔥</div>' +
      '<p class="geo-subtitle">' + subtitle + '</p>' +
      '<div class="geo-marquee"><span class="geo-marquee-inner">' + marquee + '</span></div>' +
      '<div class="geo-counter-block">' +
        '<div class="geo-counter-label-top">You are visitor number:</div>' +
        '<div class="geo-counter" id="geo-visitor-counter">' + padded(visitorFloor(seed), 6) + '</div>' +
        '<div class="geo-counter-sublabel">since ' + since + '</div>' +
      '</div>' +
      '<p class="geo-gallery-intro">— ' + (cfg.galleryIntro || 'My Art Gallery — click any pic for full size!!') + ' —</p>' +
      '<div class="geo-grid">' + thumbsHtml + '</div>' +
      (cfg.underConstruction !== false
        ? '<p class="geo-construction">🚧 <span class="geo-blink">UNDER CONSTRUCTION</span> — more pics coming soon!! 🚧</p>'
        : '');
  }

  function buildImagePageHTML(img, viewCount, cfg) {
    var name     = img.name || 'image.jpg';
    var src      = img.src  || '';
    var artist   = cfg.artistName  || 'squiche';
    var siteName = cfg.siteName    || 'squiche.com';
    var base     = cfg.fakeBaseUrl || 'http://www.coolartbysquiche.com/images/';

    var imgHtml = src
      ? '<img src="' + src + '" alt="' + name + '" draggable="false">'
      : '<div class="geo-full-placeholder"><span style="font-size:40px">🖼️</span><span>' + name + '</span></div>';

    // Instagram link — show row only if URL is provided
    var igRow = img.instagramUrl
      ? '<tr><td>Instagram:</td><td><a href="' + img.instagramUrl + '" target="_blank" rel="noopener">View on Instagram ↗</a></td></tr>'
      : '';

    /* Shop links — only rendered for pieces that actually have a product.
       Most of the gallery has none yet, and an image without links should
       look finished, not broken, so nothing is drawn in that case. */
    var shop = (img.shop && img.shop.length) ? img.shop : [];
    var shopRow = shop.length
      ? '<tr><td>Available:</td><td>' +
          shop.map(function (sp) {
            return '<a href="#" class="geo-shop-link" data-geo-product="' +
                   String(sp.handle).replace(/"/g, '&quot;') + '">' + sp.label + ' \u2197</a>';
          }).join(' &nbsp;\u00b7&nbsp; ') +
        '</td></tr>'
      : '';

    // Comments — use per-image comments if set, otherwise nothing
    var comments = (img.comments && img.comments.length) ? img.comments : [];
    var commentsHtml = comments.length
      ? '<div class="geo-comments-box">' +
          '<div class="geo-comments-heading">Comments (' + comments.length + ')</div>' +
          comments.map(function (c) {
            return '<div class="geo-comment"><span class="geo-comment-author">' + c.username + '</span>: ' + c.text + '</div>';
          }).join('') +
        '</div>'
      : '';

    return '' +
      '<a class="geo-back-link" data-geo-back>← Back to Gallery</a>' +
      '<div class="geo-image-title">' + name + '</div>' +
      '<div class="geo-full-img-wrap" oncontextmenu="return false">' +
        imgHtml +
        '<div class="geo-watermark-text">© ' + siteName + ' — do not repost</div>' +
      '</div>' +
      '<table class="geo-img-details">' +
        '<tr><td>Filename:</td><td>' + name + '</td></tr>' +
        '<tr><td>Views:</td><td><span id="geo-detail-views">' + viewCount + '</span></td></tr>' +
        '<tr><td>Artist:</td><td>' + artist + '</td></tr>' +
        igRow +
        shopRow +
      '</table>' +
      '<div class="geo-share-box"><p>Share this image:</p>' +
        '<div class="geo-share-row">' +
          '<span class="geo-share-label">Direct link:</span>' +
          '<input class="geo-share-input" id="geo-share-url" type="text" readonly value="' + (src || base + name) + '">' +
          '<button class="geo-share-copy" data-geo-copy="geo-share-url">Copy</button>' +
        '</div>' +
      '</div>' +
      commentsHtml +
      '<a class="geo-back-link" data-geo-back>← Back to Gallery</a>';
  }

  /* ═══════════════════════════════════════════════════════════
     § 6  MOUNT + WIRE
  ═══════════════════════════════════════════════════════════ */

  var _reloadFn = null;

  function mount(containerEl, _cfg) {
    var geoCfg = getGeoCfg();

    /* If the merchant pasted a Counter API URL (e.g. their own Cloudflare
       Worker), use that as COUNTER_BASE. Empty string → keep the Abacus
       default. Strip any trailing slash so we don't double-slash the path. */
    if (geoCfg.counterUrl && typeof geoCfg.counterUrl === 'string') {
      var customBase = geoCfg.counterUrl.trim().replace(/\/$/, '');
      if (customBase) COUNTER_BASE = customBase;
    }

    injectCSS(geoCfg.backgroundUrl || null);

    var root = document.createElement('div');
    root.className = 'geo';
    containerEl.appendChild(root);

    function refreshConfig() { geoCfg = getGeoCfg(); }

    var shuffledImages   = [];
    var galleryScrollTop = 0;   // saved scroll position before entering an image detail

    function showGallery(isBack) {
      // Only reshuffle on a fresh arrival — not when the user clicks Back from an image
      if (!isBack) {
        shuffledImages = shuffleArr(geoCfg.images || []);
      }
      var shuffledCfg = {};
      for (var k in geoCfg) {
        if (Object.prototype.hasOwnProperty.call(geoCfg, k)) shuffledCfg[k] = geoCfg[k];
      }
      shuffledCfg.images = shuffledImages;

      root.innerHTML = buildGalleryHTML(shuffledCfg);
      /* Indexes must match the array buildGalleryHTML just mapped over. */
      hydrateGalleryCounts(root, shuffledCfg.images || []);
      root.classList.remove('showing-image');
      wireGallery();

      // Counter: show seed immediately, then animate to seed + global API count.
      // Only fire the API on a fresh page arrival, not when returning from an image.
      if (!isBack) {
        var seed           = geoCfg.counterSeed || 0;
        var alreadyVisited = !!ssGet(SS_VISITED);
        if (!alreadyVisited) ssSet(SS_VISITED, '1');
        var counterEl = root.querySelector('#geo-visitor-counter');
        var floor     = visitorFloor(seed);   // what's already on screen
        fetchAndIncrementVisitor(alreadyVisited, function (apiCount) {
          if (!counterEl || !document.contains(counterEl)) return;

          /* Abacus unreachable: keep whatever floor is already painted.
             Previously this returned early and left the bare seed, which is
             how the counter ended up running backwards. */
          if (apiCount === null) return;

          /* Never regress. The server total is authoritative when it's ahead,
             but a transient low/failed read must never lower the display. */
          var target = Math.max(seed + apiCount, floor);
          setCachedVisitorTotal(target);
          if (target === floor) return;       // already correct, no animation
          animateCount(counterEl, floor, target, 1200, 6);
        });
      }

      // Restore the exact scroll position the user was at before opening the image
      containerEl.scrollTop = isBack ? galleryScrollTop : 0;
    }

    function showImage(index) {
      galleryScrollTop = containerEl.scrollTop;  // save so Back restores the exact spot
      var img = shuffledImages[index];
      if (!img) return;

      var countBefore = getViewCount(img.name);
      /* Pass an updater that re-renders the detail count once the global
         number comes back from Abacus. The user sees their optimistic
         local +1 immediately, then a quiet jump to the global total. */
      var countAfter  = getOrIncrementView(img.name, function (globalCount) {
        var detailEl2 = root.querySelector('#geo-detail-views');
        if (detailEl2) animateCount(detailEl2, parseInt(detailEl2.textContent, 10) || 0, globalCount, 600, 0);
      });

      // Update the thumb count span in the now-hidden gallery so it's right on return
      var thumbSpan = root.querySelector('[data-geo-count="' + index + '"]');
      if (thumbSpan) thumbSpan.textContent = countAfter;

      root.innerHTML = buildImagePageHTML(img, countAfter, geoCfg);
      root.classList.add('showing-image');

      // Animate detail count only if it actually incremented this click
      if (countAfter > countBefore) {
        var detailEl = root.querySelector('#geo-detail-views');
        if (detailEl) animateCount(detailEl, countBefore, countAfter, 800, 0);
      }

      wireImagePage();
      containerEl.scrollTop = 0;
    }

    function wireGallery() {
      /* Warm the full-size art behind whichever thumbnails are on screen.

         Each gallery entry carries two URLs: `thumb` for the grid and `src`
         for the detail view. Only the thumbs are in the DOM, so page-level
         warming never touched the full-size files — which is why clicking a
         piece stalled while the big image fetched. Measured: a warmed piece
         opens in 8ms, an unwarmed one in 1430ms.

         Warming a fixed first-N does not work for a 97-image gallery: scroll
         past it and you are back to the stall. Warming all 97 is far too much
         to spend on a maybe. So warm what the visitor can actually see, plus
         a screen of lead-in — by the time a thumbnail has been looked at, the
         full-size behind it is already in cache. warmImages() dedupes, so a
         thumbnail scrolling in and out costs one request at most. */
      var warm = window.OS9Windows && window.OS9Windows.warmImages;
      if (warm && window.IntersectionObserver) {
        var io = new IntersectionObserver(function (entries) {
          var urls = [];
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            var item = shuffledImages[parseInt(e.target.dataset.geoIndex, 10)];
            if (item && item.src) urls.push(item.src);
            io.unobserve(e.target);          // once warmed, stop watching it
          });
          if (urls.length) warm(urls);
        }, { root: containerEl, rootMargin: '600px 0px' });
        root.querySelectorAll('[data-geo-index]').forEach(function (t) { io.observe(t); });
      } else if (warm) {
        /* No IntersectionObserver: fall back to the first dozen. */
        warm(shuffledImages.slice(0, 12).map(function (i) { return i && i.src; }).filter(Boolean));
      }

      root.querySelectorAll('[data-geo-index]').forEach(function (thumb) {
        function open() { showImage(parseInt(thumb.dataset.geoIndex, 10)); }

        /* Warm on intent. Pointing at a thumbnail is a far better predictor of
           a click than merely scrolling past it, and it buys the couple of
           hundred milliseconds between the cursor arriving and the button
           going down — usually enough to have the full-size file in hand
           before it is asked for. Touch gets the same head start from
           touchstart, which lands before the tap completes. warmImages()
           dedupes, so this costs nothing when the viewport pass already got
           there first. */
        function warmThis() {
          var w = window.OS9Windows && window.OS9Windows.warmImages;
          var item = shuffledImages[parseInt(thumb.dataset.geoIndex, 10)];
          if (w && item && item.src) w([item.src]);
        }
        thumb.addEventListener('mouseenter', warmThis, { passive: true });
        thumb.addEventListener('touchstart', warmThis, { passive: true });
        thumb.addEventListener('focus', warmThis);

        thumb.addEventListener('click', open);
        thumb.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
        });
      });
    }

    function wireImagePage() {
      // "Back to Gallery" links within the page
      root.querySelectorAll('[data-geo-back]').forEach(function (a) {
        a.addEventListener('click', function (e) { e.preventDefault(); showGallery(true); });
      });
      // Copy button
      root.querySelectorAll('[data-geo-copy]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = root.querySelector('#' + btn.dataset.geoCopy);
          if (!input) return;
          if (navigator.clipboard) {
            navigator.clipboard.writeText(input.value).catch(function () {});
          } else { input.select(); document.execCommand('copy'); }
        });
      });
      /* Shop links — the Browser is the portfolio, the Finder is the store,
         so buying always hands off to the Finder rather than opening a
         second shopping surface here. */
      root.querySelectorAll('[data-geo-product]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          e.preventDefault();
          var handle = a.dataset.geoProduct;
          if (handle && window.OS9Windows && window.OS9Windows.openProduct) {
            window.OS9Windows.openProduct({ handle: handle });
          }
        });
      });
      // Block right-click on full image
      var wrap = root.querySelector('.geo-full-img-wrap');
      if (wrap) wrap.addEventListener('contextmenu', function (e) { e.preventDefault(); });
    }

    showGallery();

    // ── Wire the browser chrome Back button ───────────────────
    // The browser window's Back button normally only switches *pages*.
    // When a user is on the image detail view (still the 'geocities' page),
    // intercept the click and call showGallery() instead.
    var browserWin = containerEl.closest('#os9-browser-win');
    var backBtn    = browserWin && browserWin.querySelector('#os9-back');
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (root.classList.contains('showing-image')) showGallery(true);
      });
    }

    // ── Shopify theme editor live-preview ─────────────────────
    _reloadFn = function () {
      refreshConfig();
      if (document.contains(root)) showGallery();
    };
    document.addEventListener('shopify:section:load', _reloadFn);
  }

  function reload() { if (_reloadFn) _reloadFn(); }

  /* ═══════════════════════════════════════════════════════════
     § 7  REGISTER
  ═══════════════════════════════════════════════════════════ */

  window.OS9BrowserPages = window.OS9BrowserPages || {};
  window.OS9BrowserPages['geocities'] = {
    label:  'Squiche Gallery',
    icon:   '🌐',
    url:    'coolartbysquiche.geocities.com',
    mount:  mount,
    reload: reload,
  };

})();